import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from './dc-base.requester';

@Injectable({
	providedIn: 'root',
})
export class TimezoneRequester extends DcBaseRequester<string> {
	protected resource: string;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('TIMEZONE');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = `${this.elementsListUrl}/{templateId}`;
	}

	public getAvailableTimezones(): Observable<Array<string>> {
		const url = this.urlService.generateUrl(this.resource, {}, {});
		return this.get<Array<string>>(
			url,
			CachePolicyEntity.build({
				policy: CachePolicy.CacheOnly,
				maxAgeInSeconds: 3600,
				isCacheable: true,
			})
		);
	}
}
